import { withJsonFormsControlProps } from '@jsonforms/react';
import { rankWith, scopeEndsWith } from '@jsonforms/core';
import { VideoFile } from './videofile';

interface VideoControlProps {
  data: any;
  handleChange(path: string, value: any): void;
  path: string;
}

const VideoFileUploadControl = ({ data, handleChange, path }: VideoControlProps) => (
  <VideoFile 
    // here we set the created video url as the field in the json schema
    url={data}
    createdSasUrl={(url: string) => handleChange(path, url)}
  />
);

export default withJsonFormsControlProps(VideoFileUploadControl);